/**
* ScenarioCommandEvent.js
* 
* Created on 2-okt-2013, 16:00:04
*
* @author Ivo Swartjes for Ranj
**/
export default class ScenarioCommandEvent {
    constructor(type, scenarioID) {
        this.type = type;
        this.scenarioID = scenarioID;
    };
}

ScenarioCommandEvent.INITIALIZE_SCENARIOS = "ScenarioCommandEvent.INITIALIZE_SCENARIOS";
ScenarioCommandEvent.PLAY_SCENARIO = "ScenarioCommandEvent.PLAY_SCENARIO";
ScenarioCommandEvent.FINISH_SCENARIO = "ScenarioCommandEvent.FINISH_SCENARIO";